/* ============================================================
   NFC Pilot Pro — theme scripts (dependency-free)
   ============================================================ */
(function () {
  'use strict';
  var d = document, w = window;
  var body = d.body;
  var reduce = w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $ = function (s, c) { return (c || d).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || d).querySelectorAll(s)); };
  var on = function (el, ev, fn, o) { if (el) el.addEventListener(ev, fn, o); };
  var routes = (function () { try { return JSON.parse(body.getAttribute('data-nfc-routes') || '{}'); } catch (e) { return {}; } })();
  var R = { root: routes.root || '/', cart: routes.cart || '/cart', add: routes.add || '/cart/add', change: routes.change || '/cart/change' };
  var moneyFormat = body.getAttribute('data-nfc-money') || '€{{amount}}';

  /* ---------- analytics hook ---------- */
  function track(name, payload) {
    payload = payload || {};
    try { w.dataLayer = w.dataLayer || []; w.dataLayer.push(Object.assign({ event: name }, payload)); } catch (e) {}
    try { if (typeof w.gtag === 'function') w.gtag('event', name, payload); } catch (e) {}
  }
  on(d, 'click', function (e) {
    var el = e.target.closest ? e.target.closest('[data-nfc-ev]') : null;
    if (!el) return;
    track(el.getAttribute('data-nfc-ev'), { location: el.getAttribute('data-nfc-loc') || '', label: (el.textContent || '').trim().slice(0, 60) });
  });

  /* ---------- money ---------- */
  function money(cents) {
    var m = moneyFormat.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = m ? m[1] : 'amount';
    var n = (Number(cents) || 0) / 100;
    var dec = key.indexOf('no_decimals') > -1 ? 0 : 2;
    var thou = ',', point = '.';
    if (key.indexOf('comma_separator') > -1) { thou = '.'; point = ','; }
    else if (key.indexOf('space_separator') > -1) { thou = ' '; point = ','; }
    else if (key.indexOf('apostrophe_separator') > -1) { thou = "'"; point = '.'; }
    var fixed = n.toFixed(dec);
    var parts = fixed.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
    var out = parts.length > 1 ? parts[0] + point + parts[1] : parts[0];
    return moneyFormat.replace(/\{\{\s*\w+\s*\}\}/, out);
  }
  w.nfcMoney = money;

  /* ---------- toast ---------- */
  var toastEl;
  function toast(msg, ms) {
    if (!toastEl) { toastEl = d.createElement('div'); toastEl.className = 'nfc-toast'; toastEl.setAttribute('role', 'status'); body.appendChild(toastEl); }
    toastEl.textContent = msg;
    toastEl.classList.add('is-on');
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(function () { toastEl.classList.remove('is-on'); }, ms || 2600);
  }

  /* ---------- reveal on scroll (with stagger) ---------- */
  $$('[data-nfc-stagger]').forEach(function (p) {
    var step = parseInt(p.getAttribute('data-nfc-stagger'), 10) || 90;
    Array.prototype.forEach.call(p.children, function (c, i) { if (c.classList.contains('nfc-rv')) c.style.transitionDelay = (i * step) + 'ms'; });
  });
  var rv = $$('.nfc-rv');
  if (rv.length) {
    if (reduce || !('IntersectionObserver' in w)) {
      rv.forEach(function (n) { n.classList.add('is-in'); });
    } else {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
      }, { rootMargin: '0px 0px -6% 0px', threshold: 0.05 });
      rv.forEach(function (n) { io.observe(n); });
    }
  }

  /* ---------- announcement rotator ---------- */
  $$('[data-nfc-ann]').forEach(function (bar) {
    var items = $$('.nfc-ann__item', bar);
    if (items.length < 2) { bar.classList.add('nfc-ann--single'); if (items[0]) items[0].classList.add('is-on'); return; }
    var i = 0, t, speed = (parseInt(bar.getAttribute('data-speed'), 10) || 5) * 1000;
    var show = function (n) { items[i].classList.remove('is-on'); i = (n + items.length) % items.length; items[i].classList.add('is-on'); };
    var start = function () { stop(); if (!reduce) t = setInterval(function () { show(i + 1); }, speed); };
    var stop = function () { clearInterval(t); };
    items[0].classList.add('is-on');
    on($('[data-nfc-ann-prev]', bar), 'click', function () { show(i - 1); start(); });
    on($('[data-nfc-ann-next]', bar), 'click', function () { show(i + 1); start(); });
    on(bar, 'mouseenter', stop); on(bar, 'mouseleave', start);
    start();
  });

  /* ---------- header, scroll progress & hero parallax ---------- */
  var hdr = $('[data-nfc-header]');
  var prog = $('[data-nfc-progress]');
  var para = reduce ? null : $('[data-nfc-parallax]');
  var ticking = false;
  var onScroll = function () {
    if (ticking) return; ticking = true;
    requestAnimationFrame(function () {
      var y = w.scrollY;
      if (hdr) hdr.classList.toggle('is-stuck', y > 6);
      if (prog) { var max = d.documentElement.scrollHeight - w.innerHeight; prog.style.width = (max > 0 ? Math.min(100, y / max * 100) : 0) + '%'; }
      if (para) { var lim = w.innerHeight * 1.2; if (y < lim) para.style.transform = 'translateY(' + (y * 0.08).toFixed(1) + 'px)'; }
      ticking = false;
    });
  };
  onScroll(); on(w, 'scroll', onScroll, { passive: true }); on(w, 'resize', onScroll);
  var navDrawer = $('[data-nfc-nav]');
  if (navDrawer) {
    var setNav = function (open) {
      navDrawer.classList.toggle('is-open', open);
      navDrawer.setAttribute('aria-hidden', open ? 'false' : 'true');
      $$('[data-nfc-nav-open]').forEach(function (b) { b.setAttribute('aria-expanded', open ? 'true' : 'false'); });
      body.classList.toggle('nfc-lock', open || (cartDrawer && cartDrawer.classList.contains('is-open')));
    };
    $$('[data-nfc-nav-open]').forEach(function (b) { on(b, 'click', function () { setNav(true); }); });
    $$('[data-nfc-nav-close]').forEach(function (b) { on(b, 'click', function () { setNav(false); }); });
    on(navDrawer, 'click', function (e) { if (e.target.closest('a')) setNav(false); });
    on(d, 'keydown', function (e) { if (e.key === 'Escape') setNav(false); });
  }

  /* ---------- cart drawer & AJAX cart ---------- */
  var cartDrawer = $('[data-nfc-cd]');
  var drawerEnabled = body.getAttribute('data-nfc-drawer') === 'true' && !!cartDrawer;

  function setCount(n) {
    $$('[data-nfc-count]').forEach(function (b) { b.textContent = n; b.hidden = !(n > 0); });
  }
  function openCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    body.classList.add('nfc-lock');
    var x = $('[data-nfc-cd-close]', cartDrawer); if (x) x.focus({ preventScroll: true });
  }
  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    if (!(navDrawer && navDrawer.classList.contains('is-open'))) body.classList.remove('nfc-lock');
  }
  function swapDrawer(html) {
    if (!cartDrawer || !html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('[data-nfc-cd-inner]');
    var cur = $('[data-nfc-cd-inner]', cartDrawer);
    if (fresh && cur) { cur.innerHTML = fresh.innerHTML; setCount(parseInt(fresh.getAttribute('data-count'), 10) || 0); cur.setAttribute('data-count', fresh.getAttribute('data-count') || '0'); }
  }
  function refreshDrawer() {
    if (!cartDrawer) return Promise.resolve();
    return fetch(R.root + '?sections=nfc-cart-drawer', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (j) { swapDrawer(j['nfc-cart-drawer']); })
      .catch(function () {});
  }
  function refreshCartPage(sections) {
    var page = $('[data-nfc-cartpage]');
    if (!page) return;
    var id = page.getAttribute('data-nfc-section-id');
    if (sections && sections[id]) {
      var doc = new DOMParser().parseFromString(sections[id], 'text/html');
      var fresh = doc.querySelector('[data-nfc-cartpage]');
      if (fresh) { page.innerHTML = fresh.innerHTML; }
    } else { w.location.reload(); }
  }
  function cartSectionsParam() {
    var list = ['nfc-cart-drawer'];
    var page = $('[data-nfc-cartpage]');
    if (page) list.push(page.getAttribute('data-nfc-section-id'));
    return list.join(',');
  }
  function busy(el, state) { if (el) el.classList.toggle('is-busy', !!state); }

  if (cartDrawer) {
    $$('[data-nfc-cd-close]', cartDrawer).forEach(function (b) { on(b, 'click', closeCart); });
    on($('[data-nfc-cd-ov]', cartDrawer), 'click', closeCart);
    on(d, 'keydown', function (e) { if (e.key === 'Escape') closeCart(); });
    if (drawerEnabled) {
      $$('[data-nfc-cart-open]').forEach(function (a) {
        on(a, 'click', function (e) { e.preventDefault(); openCart(); refreshDrawer(); });
      });
    }
  }
  // initial count
  if (w.fetch) {
    fetch(R.cart + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { if (c && typeof c.item_count === 'number') setCount(c.item_count); })
      .catch(function () {});
  }

  // add to cart
  function addToCart(form) {
    var btn = $('[data-nfc-atc]', form);
    var fd = new FormData(form);
    fd.append('sections', cartSectionsParam());
    fd.append('sections_url', w.location.pathname);
    busy(btn, true);
    return fetch(R.add + '.js', { method: 'POST', body: fd, headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        busy(btn, false);
        if (!res.ok) { toast(res.j && (res.j.description || res.j.message) || 'Could not add to cart.'); return; }
        if (res.j.sections) { swapDrawer(res.j.sections['nfc-cart-drawer']); }
        track('add_to_cart', { variant: fd.get('id'), location: form.getAttribute('data-nfc-loc') || '' });
        if (drawerEnabled) { openCart(); if (!res.j.sections) refreshDrawer(); }
        else { w.location.href = R.cart; }
      })
      .catch(function () { busy(btn, false); form.submit(); });
  }
  $$('[data-nfc-form]').forEach(function (form) {
    on(form, 'submit', function (e) {
      if (!w.fetch || !w.FormData) return;
      e.preventDefault();
      addToCart(form);
    });
  });

  // quantity / remove / upgrade (event delegation: drawer + cart page)
  function changeLine(payload, ctx) {
    payload.sections = cartSectionsParam();
    busy(cartDrawer, true); busy($('[data-nfc-cartpage]'), true);
    return fetch(R.change + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload) })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        busy(cartDrawer, false); busy($('[data-nfc-cartpage]'), false);
        if (c.sections) { swapDrawer(c.sections['nfc-cart-drawer']); refreshCartPage(c.sections); }
        if (typeof c.item_count === 'number') setCount(c.item_count);
        return c;
      })
      .catch(function () { busy(cartDrawer, false); w.location.reload(); });
  }
  on(d, 'click', function (e) {
    var t = e.target;
    var qb = t.closest && t.closest('[data-nfc-qty-btn]');
    if (qb) {
      e.preventDefault();
      var wrap = qb.closest('.nfc-qty');
      var input = $('input', wrap);
      var line = parseInt(qb.getAttribute('data-line'), 10);
      var q = Math.max(0, (parseInt(input.value, 10) || 0) + (qb.getAttribute('data-nfc-qty-btn') === 'plus' ? 1 : -1));
      changeLine({ line: line, quantity: q });
      return;
    }
    var rm = t.closest && t.closest('[data-nfc-remove]');
    if (rm) { e.preventDefault(); changeLine({ line: parseInt(rm.getAttribute('data-line'), 10), quantity: 0 }); return; }
    var up = t.closest && t.closest('[data-nfc-upgrade]');
    if (up) {
      e.preventDefault();
      var lineN = parseInt(up.getAttribute('data-line'), 10);
      var variantId = up.getAttribute('data-variant');
      changeLine({ line: lineN, quantity: 0 }).then(function () {
        var fd = new FormData();
        fd.append('id', variantId); fd.append('quantity', '1');
        fd.append('sections', cartSectionsParam());
        return fetch(R.add + '.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
      }).then(function (j) {
        if (j && j.sections) { swapDrawer(j.sections['nfc-cart-drawer']); refreshCartPage(j.sections); }
        toast('Upgraded to the bigger box.');
      }).catch(function () { w.location.reload(); });
    }
  });
  on(d, 'change', function (e) {
    var input = e.target;
    if (!input.matches || !input.matches('[data-nfc-qty-input]')) return;
    var q = Math.max(0, parseInt(input.value, 10) || 0);
    changeLine({ line: parseInt(input.getAttribute('data-line'), 10), quantity: q });
  });

  /* ---------- bundle picker ---------- */
  $$('[data-nfc-buy]').forEach(function (box) {
    var form = $('[data-nfc-form]', box);
    var json = $('script[data-nfc-variants]', box);
    if (!form || !json) return;
    var variants = [];
    try { variants = JSON.parse(json.textContent || '[]'); } catch (e) {}
    variants.sort(function (a, b) { return a.size - b.size; });
    var perOf = function (v) { return Math.round(v.price / (v.size || 1)); };
    var base = variants[0];
    var scope = box.closest('[data-nfc-buy-scope]') || box;
    var sync = function () {
      var sel = $('[data-nfc-opt]:checked', form);
      if (!sel) return;
      var cur = null, next = null;
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === String(sel.value)) { cur = variants[i]; next = variants[i + 1] || null; break; }
      }
      if (!cur) return;
      var idInput = $('input[name="id"]', form); if (idInput) idInput.value = cur.id;
      $$('[data-nfc-price]', scope).forEach(function (n) { n.textContent = money(cur.price); });
      $$('[data-nfc-per]', scope).forEach(function (n) { n.textContent = money(perOf(cur)) + ' / card'; });
      $$('[data-nfc-compare]', scope).forEach(function (n) {
        var full = base ? Math.round(perOf(base) * cur.size) : 0;
        if (full > cur.price) { n.textContent = money(full); n.hidden = false; } else { n.hidden = true; }
      });
      $$('[data-nfc-atc-price]', box).forEach(function (n) { n.textContent = money(cur.price); });
      $$('[data-nfc-atc-title]', box).forEach(function (n) { n.textContent = cur.title; });
      var sticky = $('[data-nfc-sticky]');
      if (sticky) { var sp = $('[data-nfc-sticky-price]', sticky); if (sp) sp.textContent = cur.title + ' · ' + money(cur.price); }
      var atc = $('[data-nfc-atc]', form);
      if (atc) { atc.disabled = !cur.available; var lab = $('[data-nfc-atc-label]', atc); if (lab) lab.textContent = cur.available ? (atc.getAttribute('data-label') || 'Add to cart') : 'Sold out'; }
      var nudge = $('[data-nfc-nudge]', box);
      if (nudge) {
        var txt = $('[data-nfc-nudge-text]', nudge) || nudge;
        if (next && perOf(next) < perOf(cur)) {
          txt.innerHTML = '<b>+' + money(next.price - cur.price) + '</b> more gets you the <b>' + next.title + '</b> box &mdash; ' + money(perOf(next)) + '/card instead of ' + money(perOf(cur)) + '/card.';
          nudge.hidden = false;
        } else if (!next && variants.length > 1) {
          txt.innerHTML = '<b>Best price per card.</b> You’re getting our lowest rate on this box.';
          nudge.hidden = false;
        } else { nudge.hidden = true; }
      }
      if (box.hasAttribute('data-nfc-update-url') && w.history && w.history.replaceState) {
        try { var u = new URL(w.location.href); u.searchParams.set('variant', cur.id); w.history.replaceState({}, '', u.toString()); } catch (e) {}
      }
    };
    on(form, 'change', function (e) { if (e.target.matches('[data-nfc-opt]')) sync(); });
    sync();
  });

  /* ---------- product gallery ---------- */
  $$('[data-nfc-gallery]').forEach(function (g) {
    var slides = $$('[data-nfc-slide]', g);
    var thumbs = $$('[data-nfc-thumb]', g);
    thumbs.forEach(function (t) {
      on(t, 'click', function () {
        var id = t.getAttribute('data-nfc-thumb');
        slides.forEach(function (s) {
          var onIt = s.getAttribute('data-nfc-slide') === id;
          s.hidden = !onIt;
          var v = s.querySelector('video'); if (v && !onIt) { try { v.pause(); } catch (e) {} }
        });
        thumbs.forEach(function (x) { x.classList.toggle('is-on', x === t); x.setAttribute('aria-current', x === t ? 'true' : 'false'); });
      });
    });
  });

  /* ---------- carousels (reviews) ---------- */
  $$('[data-nfc-carousel]').forEach(function (c) {
    var track = $('[data-nfc-track]', c);
    var slides = track ? Array.prototype.slice.call(track.children) : [];
    if (!track || slides.length < 2) { var nav = $('.nfc-carousel__nav', c); if (nav) nav.hidden = true; return; }
    var dotsWrap = $('[data-nfc-dots]', c);
    var dots = [];
    if (dotsWrap) {
      slides.forEach(function (_, i) {
        var b = d.createElement('button'); b.type = 'button'; b.setAttribute('aria-label', 'Go to review ' + (i + 1));
        on(b, 'click', function () { go(i); });
        dotsWrap.appendChild(b); dots.push(b);
      });
    }
    var step = function () { var s = slides[0]; var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0; return s.getBoundingClientRect().width + gap; };
    var index = function () { return Math.round(track.scrollLeft / step()); };
    var go = function (i) { i = Math.max(0, Math.min(slides.length - 1, i)); track.scrollTo({ left: i * step(), behavior: reduce ? 'auto' : 'smooth' }); };
    var paint = function () { var i = index(); dots.forEach(function (b, k) { b.classList.toggle('is-on', k === i); }); };
    on($('[data-nfc-prev]', c), 'click', function () { go(index() - 1); });
    on($('[data-nfc-next]', c), 'click', function () { go(index() + 1); });
    var raf; on(track, 'scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(paint); }, { passive: true });
    paint();
  });

  /* ---------- video ---------- */
  $$('[data-nfc-video]').forEach(function (v) {
    var play = $('[data-nfc-play]', v);
    var vid = $('video', v);
    var ext = v.getAttribute('data-nfc-video-ext');
    if (play && vid) {
      on(play, 'click', function () { play.hidden = true; vid.controls = true; vid.muted = false; vid.play().catch(function () {}); });
    } else if (play && ext) {
      on(play, 'click', function () {
        var src = ext;
        var yt = ext.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|shorts\/))([\w-]{6,})/);
        var vm = ext.match(/vimeo\.com\/(?:video\/)?(\d+)/);
        if (yt) src = 'https://www.youtube.com/embed/' + yt[1] + '?autoplay=1&rel=0&playsinline=1';
        else if (vm) src = 'https://player.vimeo.com/video/' + vm[1] + '?autoplay=1';
        var f = d.createElement('iframe');
        f.src = src; f.allow = 'autoplay; fullscreen; picture-in-picture'; f.setAttribute('allowfullscreen', ''); f.title = 'Product video';
        v.appendChild(f); play.hidden = true;
      });
    }
  });

  /* ---------- sticky add-to-cart (product page) ---------- */
  var sticky = $('[data-nfc-sticky]');
  if (sticky) {
    var mainForm = $('[data-nfc-form][data-nfc-main]');
    var mainBtn = mainForm ? $('[data-nfc-atc]', mainForm) : null;
    var footer = $('[data-nfc-footer]');
    var pastBtn = false, atFooter = false;
    var apply = function () { sticky.classList.toggle('is-on', pastBtn && !atFooter); };
    if ('IntersectionObserver' in w && mainBtn) {
      new IntersectionObserver(function (en) { var r = en[0]; pastBtn = !r.isIntersecting && r.boundingClientRect.top < 0; apply(); }, { threshold: 0 }).observe(mainBtn);
      if (footer) new IntersectionObserver(function (en) { atFooter = en[0].isIntersecting; apply(); }, { threshold: 0.05 }).observe(footer);
    }
    on($('[data-nfc-sticky-btn]', sticky), 'click', function () {
      if (!mainForm) return;
      if (mainForm.requestSubmit) mainForm.requestSubmit(); else mainForm.dispatchEvent(new Event('submit', { cancelable: true }));
    });
  }

  /* ---------- delivery estimate ---------- */
  $$('[data-nfc-eta]').forEach(function (el) {
    var min = parseInt(el.getAttribute('data-min'), 10), max = parseInt(el.getAttribute('data-max'), 10);
    if (!min || !max) return;
    var fmt = function (days) { var t = new Date(); t.setDate(t.getDate() + days); try { return new Intl.DateTimeFormat('en', { month: 'short', day: 'numeric' }).format(t); } catch (e) { return t.toDateString().slice(4, 10); } };
    el.textContent = fmt(min) + ' – ' + fmt(max);
  });

  /* ---------- smooth anchor offset for sticky header ---------- */
  on(d, 'click', function (e) {
    var a = e.target.closest && e.target.closest('a[href*="#"]');
    if (!a) return;
    var href = a.getAttribute('href');
    var hash = href.slice(href.indexOf('#'));
    var pathPart = href.slice(0, href.indexOf('#'));
    if (pathPart && pathPart !== w.location.pathname && pathPart !== '/' + w.location.pathname.replace(/^\//, '') && !(pathPart === '/' && w.location.pathname === '/')) return;
    if (hash.length < 2) return;
    var target = d.getElementById(hash.slice(1));
    if (!target) return;
    e.preventDefault();
    var top = target.getBoundingClientRect().top + w.scrollY - ((hdr ? hdr.offsetHeight : 0) + 12);
    w.scrollTo({ top: top, behavior: reduce ? 'auto' : 'smooth' });
    try { history.pushState(null, '', hash); } catch (err) {}
  });
})();
